import { render, staticRenderFns } from "./betReward.vue?vue&type=template&id=5cbacbdb&scoped=true"
import script from "./betReward.vue?vue&type=script&lang=js"
export * from "./betReward.vue?vue&type=script&lang=js"
import style0 from "./betReward.vue?vue&type=style&index=0&id=5cbacbdb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbacbdb",
  null
  
)

export default component.exports